@if (isInactive$ | async) {
	<div class="modal-header">
		<h3 class="modal-title">{{ 'UserSession.Disconnected.Title' | translate }}</h3>
	</div>
	<div class="modal-body">
		{{ 'UserSession.Disconnected.Question' | translate }}
	</div>
	<div class="modal-footer d-flex flex-row-reverse">
		<div class="modal-footer">
			<button type="button"
					(click)="logout()"
					class="btn btn-primary"
					translate="Actions.LoginAgain" data-cy="LoginAgain"></button>
		</div>
	</div>
}
@else {
	<div class="modal-header">
		<h3 class="modal-title">{{ 'UserSession.InactivityWarning.Title' | translate }}</h3>
	</div>
	<div class="modal-body">
		{{ 'UserSession.InactivityWarning.Question' | translate : { countdown: (countdown$ | async) } }}
	</div>
	<div class="modal-footer d-flex flex-row-reverse">
		<div class="modal-footer">
			<button type="button"
					(click)="stayAlive()"
					class="btn btn-primary"
					translate="CommonTexts.Yes"></button>
		</div>
	</div>
}



